export default "__VITE_ASSET__Ci3_zLiO__ 400w, __VITE_ASSET__E_$b_sju__ 800w, __VITE_ASSET__le26OKrq__ 1024w";